module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('div', {
    staticClass: "inbox"
  }, [_c('bsf-page-header', [_c('h3', {
    slot: "header"
  }, [_vm._v("layout 布局 ")])]), _vm._v(" "), _c('breadcrumb', {
    attrs: {
      "data": _vm.$store.state.bcArray
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('bsf-layout', [_c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "12"
    }
  }, [_c('bsf-panel', [_c('h5', {
    staticClass: "panel-title",
    slot: "title"
  }, [_vm._v("布局")]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('bsf-layout', [_c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "8"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('bsf-doc', [_c('bsf-docmix', [_c('h5', {
    slot: "default"
  })])])], true)]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "6"
    }
  }, [_c('bsf-panel', [_c('h5', {
    staticClass: "panel-title",
    slot: "title"
  }, [_vm._v("图表 Echart")]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('bsf-chart')])], true)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-269e6c66!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/grid.vue
// module id = 297
// module chunks = 2